export enum UploadBasketOptions {
  Now,
  Future,
  IsConsignment,
}
